<template>
  <div class="text-center">
    <div class="d-flex align-center mb-2">
      <v-btn
        icon="arrow_back"
        flat
        @click="back"
      />
      <h6>
        {{ title }}
      </h6>
    </div>

    <AccountLogin
      v-model="selectedUser"
      small
      show-impersonate
      :class="{
        'px-md-16': selectedUser.id != $auth.user!.id
      }"
      @success="$emit('success')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import AccountLogin from "@/components/AccountLogin.vue"
import {roles} from "@/enums/roles"

export default defineComponent({
  components: {AccountLogin},
  emits: ['back', 'success'],
  data() {
    return {
      selectedUser: this.$auth.user! as App.Models.User,
      roles,
    }
  },
  computed: {
    title() {
      return (!this.selectedUser || this.selectedUser.id == this.$auth.user!.id)
        ? 'Select a user account'
        : `Enter ${this.selectedUser.name_abbr}'s PIN`
    }
  },
  methods: {
    back() {
      if (!this.selectedUser || this.selectedUser.id == this.$auth.user!.id) {
        this.$emit('back')
      } else {
        this.selectedUser = this.$auth.user!
      }
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
